import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
import collection from "@/assets/js/functions/firebase/firestore/collection";

const state = {
  user: {},
  office: {},
  hasUserDetail: false,
  isClient: false,
  isOperator: false,
  isOwner: false,
};

const getters = {
  user: state => state.user,
  office: state => state.office,
  uid: state => state.user.uid,
  isLogin: state => !!(state.user.uid && state.user.emailVerified),
  isLoginButNotVerified: state => !!state.user.uid && !state.user.emailVerified,

  customClaim: (state) => ({
    hasUserDetail: state.hasUserDetail,
    isClient: state.isClient,
    isOperator: state.isOperator,
    isOwner: state.isOwner,
  }),
};

const actions = {
  async setUser(context, user) {
    if (user.uid) {
      context.commit('changeUser', user);
      await context.dispatch('setOffice', user.uid);
      const customClaim = await user.getIdTokenResult(true);
      await context.dispatch('setHasUserDetail', {uid: user.uid, hasUserDetail: customClaim.claims.hasUserDetail});
      await context.dispatch('setIsClient', {uid: user.uid, isClient: customClaim.claims.isClient});
      await context.dispatch('setIsOperator', {uid: user.uid, isOperator: customClaim.claims.isOperator});
      await context.dispatch('setIsOwner', {uid: user.uid, isOwner: customClaim.claims.isOwner});
    } else {
      context.commit('changeUser', user);
      context.commit('changeCustomClaimUserDetail', null);
      context.commit('changeCustomClaimClient', null);
      context.commit('changeCustomClaimOperator', null);
      context.commit('changeCustomClaimOwner', null);
      await context.dispatch('setOffice', null);
    }
  },

  async setOffice(context, uid) {
    let office = {};
    if (uid) {
      const userDetail = await collection.methods.getDoc(COLLECTION_NAMES.USER_DETAILS, uid);
      if (userDetail && userDetail.office) {
        office = await collection.methods.getDoc(COLLECTION_NAMES.OFFICES, userDetail.office.id);
        if (office.id && office.owner) office.owner = {id: office.owner.id};
      }
    }
    context.commit('changeOffice', office);
  },

  async setHasUserDetail(context, params) {
    if (params.hasUserDetail) {
      context.commit('changeCustomClaimUserDetail', params.hasUserDetail);
    } else {
      const userDetail = await collection.methods.getDoc(COLLECTION_NAMES.USER_DETAILS, params.uid);
      context.commit('changeCustomClaimUserDetail', !!userDetail);
    }
  },
  async setIsClient(context, params) {
    if (params.isClient) {
      context.commit('changeCustomClaimClient', params.isClient);
    } else {
      const client = await collection.methods.getDoc(COLLECTION_NAMES.CLIENTS, params.uid);
      context.commit('changeCustomClaimClient', !!client);
    }
  },
  async setIsOperator(context, params) {
    if (params.isOperator) {
      context.commit('changeCustomClaimOperator', params.isOperator);
    } else {
      const operator = await collection.methods.getDoc(COLLECTION_NAMES.OPERATORS, params.uid);
      context.commit('changeCustomClaimOperator', !!operator);
    }
  },
  async setIsOwner(context, params) {
    if (params.isOwner) {
      context.commit('changeCustomClaimOwner', params.isOwner);
    } else {
      const ownerPath = collection.methods.getDocPath(COLLECTION_NAMES.USER_DETAILS, params.uid);
      const query = collection.methods.getDocRef(COLLECTION_NAMES.OFFICES).where('owner', '==', ownerPath);
      const offices = await collection.methods.retrieveDocs(query);
      context.commit('changeCustomClaimOwner', !!offices[0]);
    }
  },
};

const mutations = {
  changeUser(state, user) {
    state.user = user;
  },
  changeOffice(state, office) {
    state.office = office;
  },
  changeCustomClaimUserDetail(state, hasUserDetail) {
    state.hasUserDetail = !!hasUserDetail;
  },
  changeCustomClaimClient(state, isClient) {
    state.isClient = !!isClient;
  },
  changeCustomClaimOperator(state, isOperator) {
    state.isOperator = !!isOperator;
  },
  changeCustomClaimOwner(state, isOwner) {
    state.isOwner = !!isOwner;
  },
};

const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default auth;
